import Vue from 'vue';
import VueAxios from 'vue-axios';
import axios from 'axios';
import { i18n } from '../i18n';

Vue.use(VueAxios, axios);

const _baseGoodiesApi = 'https://www.api.funnylabz.com/common/goodies';
const _baseGoodiesFallbackApi = 'https://www.fallback.api.funnylabz.com/common/goodies';

let static_goodies_locale = null;
let static_goodies_query_in_progress = false;
let static_goodies = null;

let static_goodies_category_locale = null;
let static_goodies_category_query_in_progress = false;
let static_goodies_category = null;

function getUserCountryCode() {
  var countryCode = '';
  var languageAndCountry = navigator.language.toLocaleLowerCase().split('-');
  if (languageAndCountry.length == 2) {
    countryCode = languageAndCountry[1];
  }

  return countryCode;
}

// Internal function to update goodies if needed
async function updateAndGetGoodiesAsync() {
  if ((static_goodies_locale === null || static_goodies_locale !== i18n.locale ||static_goodies === null) && !static_goodies_query_in_progress) {
    static_goodies_query_in_progress = true;

    static_goodies_locale = null;
    static_goodies = null;

    // If language changed or goodies never retrieved, we get it again
    try
    {
      var countryCode = getUserCountryCode();

      const response = await axios.get(`${_baseGoodiesApi}/content/all/${countryCode}/${i18n.locale}`);
      console.log(`Received goodies from base API in '${i18n.locale}' language and '${countryCode}' country.`);
      static_goodies = response.data;
      static_goodies_locale = i18n.locale;
      static_goodies_query_in_progress = false;
    }
    catch (error)
    {
      console.log(`No reponse received from base API to get goodies content, trying to use fallback API instead... We will not query country specific information...: ${error.message}`);
      try
      {
        const response = await axios.get(`${_baseGoodiesFallbackApi}/content/all/${i18n.locale}`);

        console.log(`Received goodies from fallback API in '${i18n.locale}' language.`);
        static_goodies = response.data;
        static_goodies_locale = i18n.locale;
        static_goodies_query_in_progress = false;
      }
      catch (error)
      {
        console.log(`No reponse received from fallback API to get goodies content... We have no way to get the content...: ${error.message}`);
        static_goodies_query_in_progress = false;
      }
    }
  }

  return static_goodies;
}

// Internal function to update goodies category if needed
async function updateAndGetGoodiesCategoryAsync() {
  if ((static_goodies_category_locale === null || static_goodies_category_locale !== i18n.locale ||static_goodies_category === null) && !static_goodies_category_query_in_progress) {
    static_goodies_category_query_in_progress = true;

    static_goodies_category_locale = null;
    static_goodies_category = null;

    // If language changed or goodies query never retrieved, we get it again
    try
    {
      const response = await axios.get(`${_baseGoodiesApi}/category/${i18n.locale}`);
      console.log(`Received goodies category from base API in '${i18n.locale}' language.`);
      static_goodies_category = response.data;
      static_goodies_category_locale = i18n.locale;
      static_goodies_category_query_in_progress = false;
    }
    catch (error)
    {
      console.log(`No reponse received from base API to get goodies category, trying to use fallback API instead...: ${error.message}`);
      try
      {
        const response = await axios.get(`${_baseGoodiesFallbackApi}/category/${i18n.locale}`);

        console.log(`Received goodies category from fallback API in '${i18n.locale}' language.`);
        static_goodies_category = response.data;
        static_goodies_category_locale = i18n.locale;
        static_goodies_category_query_in_progress = false;
      }
      catch (error)
      {
        console.log(`No reponse received from fallback API to get goodies category... We have no way to get the categories...: ${error.message}`);
        static_goodies_category_query_in_progress = false;
      }
    }
  }

  return static_goodies_category;
}

export async function waitGoodiesInitialized(initializeAlsoCategory) {
  // console.log("Received request to wait goodies to be initialized...");
  var previousGoodies = static_goodies;
  var resGoodies = await updateAndGetGoodiesAsync();

  var result = false;
  if (initializeAlsoCategory) {
    var previousGoodiesCategory = static_goodies_category;
    var resGoodiesCategory = await updateAndGetGoodiesCategoryAsync();

    result = (resGoodiesCategory != previousGoodiesCategory);
  }

  return (resGoodies != previousGoodies) || result;
}

// Get the ordered list of all categories containing at least one goodies
export function orderedCategories() {
  var orderedCategories = Array();
  // Add all categories containing at least one goodies
  if (static_goodies_category != null && static_goodies != null) {
    for (let i_category = 0; i_category < static_goodies_category.length; i_category++) {
      for (let i_goodie = 0 ; i_goodie < static_goodies.length; i_goodie++) {
        if (static_goodies[i_goodie]['category_code'] == static_goodies_category[i_category]['code']) {
          if (!orderedCategories.includes(static_goodies_category[i_category])) {
            orderedCategories.push(static_goodies_category[i_category]);
          }
        }
      }
    }
  }

  // Order categories by popularity
  orderedCategories = orderedCategories.sort(function(cat1, cat2) {
      return (cat1['popularity'] < cat2['popularity']) ? 1 : -1;
  });

  return orderedCategories;
}

// Get the ordered list of all goodies for a specific category
export function orderedGoodies(categoryCode = 'all', onlyTrending = false) {
  var orderedGoodies = null;

  if (static_goodies != null) {
      // Get the list of all goodies with the correct category
      orderedGoodies = static_goodies.filter(goodie => ((goodie['category_code'] == categoryCode || categoryCode == 'all')
                                                      && (!onlyTrending || goodie['is_trending'] == true || goodie['is_trending'] == 1)));

      // Order goodies by popularity
      orderedGoodies = orderedGoodies.sort(function(goodie1, goodie2) {
          return (goodie1['popularity'] < goodie2['popularity']) ? 1 : -1;
      });
  }

  return orderedGoodies;
}
